// https://www.hyperscan.com/api-docs
// https://www.hyperscan.com/api/v2/tokens?items_count=1000
// https://github.com/HyperSwapX/hyperswap-token-list/blob/main/tokens.json

import { SupportedUnderlyingAssetSymbols } from '@/enums'
import { HyperscanToken, HyperswapToken } from '@/interfaces'

export const hardcodedTokensList: HyperscanToken[] = [
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0x7f5aB8f7974FCcd857163E5DA649Eb2588201dF1',
        circulating_market_cap: null,
        decimals: '18',
        exchange_rate: null,
        holders: '31435',
        icon_url: null,
        name: 'HyperGun',
        symbol: 'HGUN',
        total_supply: '100000999000000000000000',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.HYPE,
        address: '0x5555555555555555555555555555555555555555',
        circulating_market_cap: null,
        decimals: '18',
        exchange_rate: null,
        holders: '14903',
        icon_url: null,
        name: 'Wrapped HYPE',
        symbol: 'WHYPE',
        total_supply: '12653586298353808193958975',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0x6eDA206207c09e5428F281761DdC0D300851fBC8',
        circulating_market_cap: null,
        decimals: null,
        exchange_rate: null,
        holders: '12340',
        icon_url: null,
        name: 'Hyperswap V3 Positions NFT-V1',
        symbol: 'HSPX-V3-POS',
        total_supply: '58090',
        type: 'ERC-721',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.HYPE,
        address: '0xfFaa4a3D97fE9107Cef8a3F48c069F577Ff76cC1',
        circulating_market_cap: null,
        decimals: '18',
        exchange_rate: null,
        holders: '11305',
        icon_url: null,
        name: 'Staked HYPE',
        symbol: 'stHYPE',
        total_supply: '11078420766077508313375418',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0x5748ae796AE46A4F1348a1693de4b50560485562',
        circulating_market_cap: null,
        decimals: '18',
        exchange_rate: null,
        holders: '10585',
        icon_url: null,
        name: 'Looped HYPE',
        symbol: 'LHYPE',
        total_supply: '1437748310044904148448954',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0x0D745EAA9E70bb8B6e2a0317f85F1d536616bD34',
        circulating_market_cap: null,
        decimals: '18',
        exchange_rate: null,
        holders: '8382',
        icon_url: null,
        name: 'HyperLend HyperEVM WHYPE',
        symbol: 'hHyperEvmWHYPE',
        total_supply: '4426495524184950054158720',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.HYPE,
        address: '0x94e8396e0869c9F2200760aF0621aFd240E1CF38',
        circulating_market_cap: null,
        decimals: '18',
        exchange_rate: null,
        holders: '7487',
        icon_url: null,
        name: 'Staked HYPE Shares',
        symbol: 'wstHYPE',
        total_supply: '11014541957908164181285096',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0x47bb061C0204Af921F43DC73C7D7768d2672DdEE',
        circulating_market_cap: null,
        decimals: '6',
        exchange_rate: null,
        holders: '7346',
        icon_url: null,
        name: 'alright buddy',
        symbol: 'BUDDY',
        total_supply: '1000000000000000',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0x74a40455Ff49ECE02009BEe405154ac9Ac3FA340',
        circulating_market_cap: null,
        decimals: '6',
        exchange_rate: null,
        holders: '7059',
        icon_url: null,
        name: 'Stonks',
        symbol: 'STONKS',
        total_supply: '1000000000000000',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0xB9201e89f94a01FF13AD4CAeCF43a2e232513754',
        circulating_market_cap: null,
        decimals: null,
        exchange_rate: null,
        holders: '6616',
        icon_url: null,
        name: 'NonfungiblePositionManager',
        symbol: 'NFP',
        total_supply: '34805',
        type: 'ERC-721',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0x7C97cd7B57b736c6AD74fAE97C0e21e856251dcf',
        circulating_market_cap: null,
        decimals: '18',
        exchange_rate: null,
        holders: '6516',
        icon_url: null,
        name: 'WHYPE Hypurr',
        symbol: 'hyWHYPE',
        total_supply: '2397008534301960711057870',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0x06c5aD0A96437eE1003390C33Cb180e5aD97e1E9',
        circulating_market_cap: null,
        decimals: null,
        exchange_rate: null,
        holders: '6116',
        icon_url: null,
        name: 'Layer3 CUBE',
        symbol: 'CUBE',
        total_supply: null,
        type: 'ERC-721',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.USD,
        address: '0x02c6a2fA58cC01A18B8D9E00eA48d65E4dF26c70',
        circulating_market_cap: null,
        decimals: '18',
        exchange_rate: null,
        holders: '5598',
        icon_url: null,
        name: 'feUSD',
        symbol: 'feUSD',
        total_supply: '45793556805911772633719228',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0x6D1aB1c149cA270F15ef2089e3D03a2CA73c1A78',
        circulating_market_cap: null,
        decimals: '18',
        exchange_rate: null,
        holders: '4984',
        icon_url: null,
        name: 'HYPE',
        symbol: 'Claim: hyperliquid-labs.com',
        total_supply: '1000000000000000000000000000',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0x96C6cBB6251Ee1c257b2162ca0f39AA5Fa44B1FB',
        circulating_market_cap: null,
        decimals: '18',
        exchange_rate: null,
        holders: '4908',
        icon_url: null,
        name: 'Hyperbeat Ultra HYPE',
        symbol: 'hbHYPE',
        total_supply: '1242414376537693066467603',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0x0Ab8AAE3335Ed4B373A33D9023b6A6585b149D33',
        circulating_market_cap: null,
        decimals: '18',
        exchange_rate: null,
        holders: '4670',
        icon_url: null,
        name: 'HyperLend HyperEVM wstHYPE',
        symbol: 'hHyperEvmwstHYPE',
        total_supply: '5903822053563373844535433',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0x4533C3002660117a56fa44ED3C4bF4b6A8E0b0A2',
        circulating_market_cap: null,
        decimals: '18',
        exchange_rate: null,
        holders: '4513',
        icon_url: null,
        name: 'Hyperlauncher',
        symbol: 'LAUNCH',
        total_supply: '50626000000000000000000000',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.BTC,
        address: '0x9FDBdA0A5e284c32744D2f17Ee5c74B284993463',
        circulating_market_cap: null,
        decimals: '8',
        exchange_rate: null,
        holders: '4354',
        icon_url: null,
        name: 'Unit Bitcoin',
        symbol: 'UBTC',
        total_supply: '2100000000000000',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.ETH,
        address: '0x1fbcCdc677c10671eE50b46C61F0f7d135112450',
        circulating_market_cap: null,
        decimals: '18',
        exchange_rate: null,
        holders: '4341',
        icon_url: null,
        name: 'Ether',
        symbol: 'ETH',
        total_supply: '22976407730977488067',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0x9Be117D27f8037F6f549903C899e96E5755e96db',
        circulating_market_cap: null,
        decimals: null,
        exchange_rate: null,
        holders: '4026',
        icon_url: null,
        name: 'Hypers',
        symbol: 'HYPR',
        total_supply: '8888',
        type: 'ERC-721',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.USD,
        address: '0xca79db4B49f608eF54a5CB813FbEd3a6387bC645',
        circulating_market_cap: null,
        decimals: '18',
        exchange_rate: null,
        holders: '3920',
        icon_url: null,
        name: 'Last USD',
        symbol: 'USDXL',
        total_supply: '3884874542080429100171735',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.USD,
        address: '0xB8CE59FC3717ada4C02eaDF9682A9e934F625ebb',
        circulating_market_cap: null,
        decimals: '6',
        exchange_rate: null,
        holders: '3836',
        icon_url: null,
        name: 'USD₮0',
        symbol: 'USD₮0',
        total_supply: '19179835852260',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.USD,
        address: '0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34',
        circulating_market_cap: null,
        decimals: '18',
        exchange_rate: null,
        holders: '3731',
        icon_url: null,
        name: 'USDeOFT',
        symbol: 'USDe',
        total_supply: '12850157214711000000000000',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.ETH,
        address: '0xBe6727B535545C67d5cAa73dEa54865B92CF7907',
        circulating_market_cap: null,
        decimals: '18',
        exchange_rate: null,
        holders: '3567',
        icon_url: null,
        name: 'Unit Ethereum',
        symbol: 'UETH',
        total_supply: '100000000000000000000000000',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0x7952D59a35aCf858556B976e8476dF7949856d0e',
        circulating_market_cap: null,
        decimals: '18',
        exchange_rate: null,
        holders: '3328',
        icon_url: null,
        name: 'sidelined',
        symbol: 'SIDE',
        total_supply: '1000000000000000000000000000',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0x6E0F6a71a74fAD5D0ED5A34b468203A4a4437b71',
        circulating_market_cap: null,
        decimals: '9',
        exchange_rate: null,
        holders: '2918',
        icon_url: null,
        name: 'EVMoon',
        symbol: 'EVM',
        total_supply: '69420000000000',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0xb50f23153cbEbaCED6F15a537e023d910905D4D5',
        circulating_market_cap: null,
        decimals: '18',
        exchange_rate: null,
        holders: '2823',
        icon_url: null,
        name: 'Hyperliquid Ape',
        symbol: 'HAPE',
        total_supply: '1000000000000000000000000',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0x39694eFF3b02248929120c73F90347013Aec834d',
        circulating_market_cap: null,
        decimals: '18',
        exchange_rate: null,
        holders: '2666',
        icon_url: null,
        name: 'stHYPE AMM',
        symbol: 'stHYPE AMM LP',
        total_supply: '1244006240924822616159837',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0x1d9d87eBc14e71490bB87f1C39F65BDB979f3cb7',
        circulating_market_cap: null,
        decimals: null,
        exchange_rate: null,
        holders: '2638',
        icon_url: null,
        name: 'Hyperliquid Names',
        symbol: 'HLN',
        total_supply: null,
        type: 'ERC-721',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0xcDBCD0617498058360F1427CD9aAB72f066080bB',
        circulating_market_cap: null,
        decimals: '6',
        exchange_rate: null,
        holders: '2609',
        icon_url: null,
        name: 'HyperLube',
        symbol: 'LUBE',
        total_supply: '1000000000000000',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0x63eb9d77D083cA10C304E28d5191321977fd0Bfb',
        circulating_market_cap: null,
        decimals: null,
        exchange_rate: null,
        holders: '2600',
        icon_url: null,
        name: 'Hypio',
        symbol: 'hypio',
        total_supply: '5256',
        type: 'ERC-721',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0x37E44F3070b5455f1f5d7aaAd9Fc8590229CC5Cb',
        circulating_market_cap: null,
        decimals: '18',
        exchange_rate: null,
        holders: '2473',
        icon_url: null,
        name: 'WHYPE Variable Debt Hypurr',
        symbol: 'variableDebtWHYPE',
        total_supply: '2141637797976624122160880',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0x9b498C3c8A0b8CD8BA1D9851d40D186F1872b44E',
        circulating_market_cap: null,
        decimals: '18',
        exchange_rate: null,
        holders: '2447',
        icon_url: null,
        name: 'Purr',
        symbol: 'PURR',
        total_supply: '600000000000000000000000000',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0xfcBc8cC69a312937F8308305Acc79D91aeA77080',
        circulating_market_cap: null,
        decimals: '18',
        exchange_rate: null,
        holders: '2439',
        icon_url: null,
        name: 'Hypio Unit Bias',
        symbol: 'HUB',
        total_supply: '5555000000000000000000',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.HYPE,
        address: '0x2831775cb5e64B1D892853893858A261E898FbEb',
        circulating_market_cap: null,
        decimals: '18',
        exchange_rate: null,
        holders: '2415',
        icon_url: null,
        name: 'wHYPE',
        symbol: 'wHYPE',
        total_supply: '393425627411735105384326',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0xdAbB040c428436d41CECd0Fb06bCFDBAaD3a9AA8',
        circulating_market_cap: null,
        decimals: '18',
        exchange_rate: null,
        holders: '2402',
        icon_url: null,
        name: 'Hyperpie Staked mHYPE',
        symbol: 'mHYPE',
        total_supply: '339701882814495496839541',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0xa0399Ff8F46Ce6C2Cfee05C5F67307C7F390a439',
        circulating_market_cap: null,
        decimals: '18',
        exchange_rate: null,
        holders: '2312',
        icon_url: null,
        name: 'USDXL Variable Debt Hypurr',
        symbol: 'variableDebtUSDXL',
        total_supply: '3896656208302885437712966',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.USD,
        address: '0xB5fE77d323d69eB352A02006eA8ecC38D882620C',
        circulating_market_cap: null,
        decimals: '18',
        exchange_rate: null,
        holders: '2047',
        icon_url: null,
        name: 'KEI Stablecoin',
        symbol: 'KEI',
        total_supply: '1507545112214640389938870',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0xfdF8B1F915198Ed043EE52ec367c3DF8ed5c9d79',
        circulating_market_cap: null,
        decimals: null,
        exchange_rate: null,
        holders: '2009',
        icon_url: null,
        name: 'Laminar V3 Positions NFT-V1',
        symbol: 'LAMINAR-V3-POS',
        total_supply: '3730',
        type: 'ERC-721',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0x7DCfFCb06B40344eecED2d1Cbf096B299fE4b405',
        circulating_market_cap: null,
        decimals: '18',
        exchange_rate: null,
        holders: '2009',
        icon_url: null,
        name: 'RUB',
        symbol: 'RUB',
        total_supply: '1000000000000000000',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0x1eE330D6d81d88915D1Be72b719e0d35c9C14C80',
        circulating_market_cap: null,
        decimals: '6',
        exchange_rate: null,
        holders: '2003',
        icon_url: null,
        name: 'Soggy Napkin',
        symbol: 'NAPKIN',
        total_supply: '1000000000000000',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0x1e38fF023BEC7b6f19322BF4acdc45b2635009FF',
        circulating_market_cap: null,
        decimals: null,
        exchange_rate: null,
        holders: '1955',
        icon_url: null,
        name: null,
        symbol: null,
        total_supply: null,
        type: 'ERC-1155',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0x1Ecd15865D7F8019D546f76d095d9c93cc34eDFa',
        circulating_market_cap: null,
        decimals: '18',
        exchange_rate: null,
        holders: '1933',
        icon_url: null,
        name: 'LiquidLaunch',
        symbol: 'LIQD',
        total_supply: '1200000000000000000000000000',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0x290e6bD2BA56DA9ab14b5bA4737dba4BAE3ed5c5',
        circulating_market_cap: null,
        decimals: null,
        exchange_rate: null,
        holders: '1922',
        icon_url: null,
        name: 'Ricardo',
        symbol: 'Ricardo',
        total_supply: '2500',
        type: 'ERC-721',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0xC8b6E0acf159E058E22c564C0C513ec21f8a1Bf5',
        circulating_market_cap: null,
        decimals: '18',
        exchange_rate: null,
        holders: '1824',
        icon_url: null,
        name: 'wstHYPE Hypurr',
        symbol: 'hywstHYPE',
        total_supply: '2758817261648292394077988',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0xFE69bc93B936B34D371defa873686C116C8488c2',
        circulating_market_cap: null,
        decimals: '6',
        exchange_rate: null,
        holders: '1792',
        icon_url: null,
        name: 'SUPERMILK',
        symbol: 'MILK',
        total_supply: '1000000000000000',
        type: 'ERC-20',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0xeA8Cc2a7da4E91c559514B8192eF1cfe1497AC74',
        circulating_market_cap: null,
        decimals: null,
        exchange_rate: null,
        holders: '1691',
        icon_url: null,
        name: 'MechaCats',
        symbol: 'MCT',
        total_supply: '5000',
        type: 'ERC-721',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0x44b598C9aCD2AeCC3FC6B285F72e434C93Ab4077',
        circulating_market_cap: null,
        decimals: null,
        exchange_rate: null,
        holders: '1627',
        icon_url: null,
        name: 'Hyparrots',
        symbol: 'HYPR',
        total_supply: '4442',
        type: 'ERC-721',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0x4C3f38129b171f02167d05E72a2994810b42f2Aa',
        circulating_market_cap: null,
        decimals: null,
        exchange_rate: null,
        holders: '1601',
        icon_url: null,
        name: 'DystoMfers',
        symbol: 'DYSTOMFER',
        total_supply: '4957',
        type: 'ERC-721',
        volume_24h: null,
    },
    {
        underlying: SupportedUnderlyingAssetSymbols.OTHERS,
        address: '0x32cCAf0381143A3952502d6B8B28AE7BC13E4Fcf',
        circulating_market_cap: null,
        decimals: '18',
        exchange_rate: null,
        holders: '1582',
        icon_url: null,
        name: 'MechaCats: Kitten Allocation',
        symbol: 'ALLOC_MECHACATS',
        total_supply: '29999303000000000000000000',
        type: 'ERC-20',
        volume_24h: null,
    },
].map((token) => ({ ...token, address: token.address.toLowerCase() }))

export const hyperswapTokenList: HyperswapToken[] = [
    {
        name: 'Wrapped Hype',
        decimals: 18,
        symbol: 'WHYPE',
        address: '0x5555555555555555555555555555555555555555',
        chainId: 999,
        logoURI: 'https://assets.coingecko.com/coins/images/50882/standard/hyperliquid.jpg?1729431300',
        tags: ['tokenv1'],
    },
    {
        name: 'Hyperbeat Ultra Hype',
        decimals: 18,
        symbol: 'hbHYPE',
        address: '0x96C6cBB6251Ee1c257b2162ca0f39AA5Fa44B1FB',
        chainId: 999,
        logoURI: 'https://www.hyperbeat.org/assets/images/vaults/hbhype.svg',
        tags: ['tokenv1'],
    },
    {
        name: 'Reverse Unit Bias',
        decimals: 18,
        symbol: 'RUB',
        address: '0x7DCfFCb06B40344eecED2d1Cbf096B299fE4b405',
        chainId: 999,
        logoURI: 'https://raw.githubusercontent.com/HyperSwapX/hyperswap-token-list/refs/heads/main/assets/rub.png',
        tags: ['tokenv1'],
    },
    {
        name: 'HyperFly',
        decimals: 18,
        symbol: 'FLY',
        address: '0x3f244819a8359145a8e7cf0272955e4918a50627',
        chainId: 999,
        logoURI: 'https://app.hyperliquid.xyz/coins/FLY_USDC.svg',
        tags: ['tokenv1'],
    },
    {
        name: 'JEFF',
        decimals: 18,
        symbol: 'JEFF',
        address: '0x52e444545fbE9E5972a7A371299522f7871aec1F',
        chainId: 999,
        logoURI: 'https://app.hyperliquid.xyz/coins/JEFF_USDC.svg',
        tags: ['tokenv1'],
    },
    {
        name: 'CATBAL',
        decimals: 18,
        symbol: 'CATBAL',
        address: '0x11735dBd0B97CfA7Accf47d005673BA185f7fd49',
        chainId: 999,
        logoURI: 'https://app.hyperliquid.xyz/coins/CATBAL_USDC.svg',
        tags: ['tokenv1'],
    },
    {
        name: 'PiP',
        decimals: 18,
        symbol: 'PiP',
        address: '0x1bEe6762F0B522c606DC2Ffb106C0BB391b2E309',
        chainId: 999,
        logoURI: 'https://app.hyperliquid.xyz/coins/PIP_USDC.svg',
        tags: ['tokenv1'],
    },
    {
        name: 'Unit Bitcoin',
        decimals: 8,
        symbol: 'UBTC',
        address: '0x9FDBdA0A5e284c32744D2f17Ee5c74B284993463',
        chainId: 999,
        logoURI: 'https://github.com/user-attachments/assets/67e8fba0-78f6-4a58-8f5a-dbef42007dbc',
        tags: ['tokenv1'],
    },
    {
        name: 'Looped Hype',
        decimals: 18,
        symbol: 'LHYPE',
        address: '0x5748ae796AE46A4F1348a1693de4b50560485562',
        chainId: 999,
        logoURI: 'https://storage.googleapis.com/stakingrewards-static/images/assets/staging/looped-hype_logo.png?v=1739880923312',
        tags: ['tokenv1'],
    },
    {
        name: 'Staked Hype',
        decimals: 18,
        symbol: 'stHYPE',
        address: '0xfFaa4a3D97fE9107Cef8a3F48c069F577Ff76cC1',
        chainId: 999,
        logoURI: 'https://github.com/user-attachments/assets/17e8e84d-869f-4853-b080-de829e993b52',
        tags: ['tokenv1'],
    },
    {
        name: 'Wrapped Staked Hype',
        decimals: 18,
        symbol: 'wstHYPE',
        address: '0x94e8396e0869c9F2200760aF0621aFd240E1CF38',
        chainId: 999,
        logoURI: 'https://github.com/user-attachments/assets/17e8e84d-869f-4853-b080-de829e993b52',
        tags: ['tokenv1'],
    },
    {
        name: 'KEI Stablecoin',
        decimals: 18,
        symbol: 'KEI',
        address: '0xB5fE77d323d69eB352A02006eA8ecC38D882620C',
        chainId: 999,
        logoURI: 'https://github.com/user-attachments/assets/05bf9af2-f89e-4478-992f-3fa27c7eb873',
        tags: ['tokenv1'],
    },
    {
        name: 'Unit Solana',
        decimals: 9,
        symbol: 'USOL',
        address: '0x068f321Fa8Fb9f0D135f290Ef6a3e2813e1c8A29',
        chainId: 999,
        logoURI: 'https://app.hyperliquid.xyz/coins/SOL_USDC.svg',
        tags: ['tokenv1'],
    },
    {
        name: 'BULBUL2DAO',
        decimals: 18,
        symbol: 'BULBUL',
        address: '0x99750393c5B40093A53ccD2d8e9f61EF4F401826',
        chainId: 999,
        logoURI: 'https://github.com/user-attachments/assets/2d5b0d9c-a537-4480-b6ff-5264b5d5ab43',
        tags: ['tokenv1'],
    },
    {
        name: 'alright buddy',
        decimals: 6,
        symbol: 'BUDDY',
        address: '0x47bb061C0204Af921F43DC73C7D7768d2672DdEE',
        chainId: 999,
        logoURI: 'https://raw.githubusercontent.com/HyperSwapX/hyperswap-token-list/refs/heads/main/assets/buddy.png',
        tags: ['tokenv1'],
    },
    {
        name: 'SUPERMILK',
        decimals: 6,
        symbol: 'MILK',
        address: '0xFE69bc93B936B34D371defa873686C116C8488c2',
        chainId: 999,
        logoURI: 'https://dd.dexscreener.com/ds-data/tokens/hyperevm/0xfe69bc93b936b34d371defa873686c116c8488c2.png?size=lg&key=076193',
        tags: ['tokenv1'],
    },
    {
        name: 'feUSD',
        decimals: 18,
        symbol: 'feUSD',
        address: '0x02c6a2fA58cC01A18B8D9E00eA48d65E4dF26c70',
        chainId: 999,
        logoURI: 'https://raw.githubusercontent.com/HyperSwapX/hyperswap-token-list/refs/heads/main/assets/feUSD.png',
        tags: ['tokenv1'],
    },
    {
        name: 'Last USD',
        decimals: 18,
        symbol: 'USDXL',
        address: '0xca79db4b49f608ef54a5cb813fbed3a6387bc645',
        chainId: 999,
        logoURI: 'https://raw.githubusercontent.com/HyperSwapX/hyperswap-token-list/refs/heads/main/assets/usdxl.svg',
        tags: ['tokenv1'],
    },
    {
        name: 'Purr',
        decimals: 18,
        symbol: 'PURR',
        address: '0x9b498C3c8A0b8CD8BA1D9851d40D186F1872b44E',
        chainId: 999,
        logoURI: 'https://assets.coingecko.com/coins/images/37125/standard/PURR_CG.png',
        tags: ['tokenv1'],
    },
    {
        address: '0x04d02CB2E963B4490Ee02b1925223d04F9d83FC6',
        name: 'CAT',
        symbol: 'CAT',
        decimals: 18,
        chainId: 999,
        logoURI: 'https://app.hyperliquid.xyz/coins/CAT_USDC.svg',
        tags: ['tokenv1'],
    },
    {
        address: '0x5804Bf271D9e691611EEA1267B24C1f3D0723639',
        name: 'First AI investment DAO on Hyperliquid',
        symbol: 'HWTR',
        decimals: 18,
        chainId: 999,
        logoURI: 'https://raw.githubusercontent.com/HyperSwapX/hyperswap-token-list/refs/heads/main/assets/HWTR.png',
        tags: ['tokenv1'],
    },
    {
        name: 'LIQD',
        decimals: 18,
        symbol: 'LIQD',
        address: '0x1Ecd15865D7F8019D546f76d095d9c93cc34eDFa',
        chainId: 999,
        logoURI: 'https://raw.githubusercontent.com/HyperSwapX/hyperswap-token-list/refs/heads/main/assets/LIQD.png',
        tags: ['tokenv1'],
    },
    {
        address: '0xbe6727b535545c67d5caa73dea54865b92cf7907',
        name: 'Unit Ethereum',
        symbol: 'UETH',
        decimals: 18,
        chainId: 999,
        logoURI: 'https://app.hyperliquid.xyz/coins/ETH.svg',
        tags: ['tokenv1'],
    },
    {
        name: 'Magpie Hype',
        decimals: 18,
        symbol: 'mHYPE',
        address: '0xdAbB040c428436d41CECd0Fb06bCFDBAaD3a9AA8',
        chainId: 999,
        logoURI: 'https://raw.githubusercontent.com/HyperSwapX/hyperswap-token-list/refs/heads/main/assets/mHYPE.jpg',
        tags: ['tokenv1'],
    },
    {
        address: '0x6f7e96C0267CD22FE04346aF21f8c6ff54372939',
        name: 'GENESY',
        symbol: 'GENESY',
        decimals: 18,
        chainId: 999,
        logoURI: 'https://app.hyperliquid.xyz/coins/GENESY_USDC.svg',
        tags: ['tokenv1'],
    },
    {
        name: 'Omni X',
        decimals: 18,
        symbol: 'OMNIX',
        address: '0x45eC8F63Fe934C0213476CFb5870835E61dd11FA',
        chainId: 999,
        logoURI: 'https://app.hyperliquid.xyz/coins/OMNIX_USDC.svg',
        tags: ['tokenv1'],
    },
    {
        address: '0xa320D9f65ec992EfF38622c63627856382Db726c',
        name: 'HFUN',
        symbol: 'HFUN',
        decimals: 18,
        chainId: 999,
        logoURI: 'https://app.hyperliquid.xyz/coins/HFUN_USDC.svg',
        tags: ['tokenv1'],
    },
    {
        address: '0x5d3a1ff2b6bab83b63cd9ad0787074081a52ef34',
        name: 'USDeOFT',
        symbol: 'USDe',
        decimals: 18,
        chainId: 999,
        logoURI: 'https://raw.githubusercontent.com/HyperSwapX/hyperswap-token-list/refs/heads/main/assets/USDe.jpg',
        tags: ['tokenv1'],
    },
    {
        address: '0x211cc4dd073734da055fbf44a2b4667d5e5fe5d2',
        name: 'Staked USDe',
        symbol: 'sUSDe',
        decimals: 18,
        chainId: 999,
        logoURI: 'https://raw.githubusercontent.com/HyperSwapX/hyperswap-token-list/refs/heads/main/assets/sUSDe.jpg',
        tags: ['tokenv1'],
    },
    {
        address: '0x7280CC1f369ab574c35cb8a8D0885e9486e3B733',
        name: 'YEETI',
        symbol: 'YEETI',
        decimals: 18,
        chainId: 999,
        logoURI: 'https://app.hyperliquid.xyz/coins/YEETI_USDC.svg',
        tags: ['tokenv1'],
    },
    {
        address: '0x6E0F6a71a74fAD5D0ED5A34b468203A4a4437b71',
        name: 'EVMoon',
        symbol: 'EVM',
        decimals: 9,
        chainId: 999,
        logoURI: 'https://dd.dexscreener.com/ds-data/tokens/hyperevm/0x6e0f6a71a74fad5d0ed5a34b468203a4a4437b71.png',
        tags: ['tokenv1'],
    },
    {
        address: '0xB8CE59FC3717ada4C02eaDF9682A9e934F625ebb',
        name: 'USDT0',
        symbol: 'USD₮0',
        decimals: 6,
        chainId: 999,
        logoURI: 'https://raw.githubusercontent.com/HyperSwapX/hyperswap-token-list/refs/heads/main/assets/USDT0.png',
        tags: ['tokenv1'],
    },
    {
        address: '0xCB0aC0aa94C67DDE8688Ac34C8E4D6C18E78B638',
        name: 'LiquidScan',
        symbol: 'LQSCAN',
        decimals: 6,
        chainId: 999,
        logoURI: 'https://raw.githubusercontent.com/HyperSwapX/hyperswap-token-list/refs/heads/main/assets/LQSCAN.png',
        tags: ['tokenv1'],
    },
    {
        address: '0x28245AB01298eaEf7933bC90d35Bd9DbCA5C89DB',
        name: 'Peg',
        symbol: 'PEG',
        decimals: 18,
        chainId: 999,
        logoURI: 'https://raw.githubusercontent.com/HyperSwapX/hyperswap-token-list/refs/heads/main/assets/PEG.png',
        tags: ['tokenv1'],
    },
    {
        address: '0x2c9634d152e8b584d4a153a78dba3e958db7b385',
        name: 'The Chameleon',
        symbol: 'CHAM',
        decimals: 6,
        chainId: 999,
        logoURI: 'https://raw.githubusercontent.com/HyperSwapX/hyperswap-token-list/refs/heads/main/assets/CHAM.svg',
        tags: ['tokenv1'],
    },
    {
        address: '0x88E7606172f587366fc6EE662Fab89543c8B33ec',
        name: 'Fish Token',
        symbol: 'FISH',
        decimals: 18,
        chainId: 999,
        logoURI: 'https://raw.githubusercontent.com/HarborFinanceHype/logo/refs/heads/main/fish.png',
        tags: ['tokenv1'],
    },
    {
        address: '0x7410E69958a8ECE2A51C231C8528513d4d668C7a',
        name: 'USDT0 Hyperliquid-RWA Strategies',
        symbol: 'hUSDT0-RWA',
        decimals: 6,
        chainId: 999,
        logoURI: 'https://raw.githubusercontent.com/Bondi-Wealth-Security/dsqlogo/refs/heads/main/Group%2048098919.jpg',
        tags: ['tokenv1'],
    },
    {
        address: '0x0ad339d66bf4aed5ce31c64bc37b3244b6394a77',
        name: 'Resolv USD',
        symbol: 'USR',
        decimals: 18,
        chainId: 999,
        logoURI: 'https://framerusercontent.com/assets/fyLd2qn65V15KmM7uJFynRYTSTk.svg',
        tags: ['tokenv1'],
    },
    {
        address: '0xe6829d9a7ee3040e1276fa75293bde931859e8fa',
        name: 'cmETH',
        symbol: 'cmETH',
        decimals: 18,
        chainId: 999,
        logoURI: 'https://raw.githubusercontent.com/HyperSwapX/hyperswap-token-list/refs/heads/main/assets/cmETH.png',
        tags: ['tokenv1'],
    },
    {
        address: '0x3b4575e689ded21caad31d64c4df1f10f3b2cedf',
        name: 'Unit Fartcoin',
        symbol: 'UFART',
        decimals: 6,
        chainId: 999,
        logoURI: 'https://raw.githubusercontent.com/HyperSwapX/hyperswap-token-list/refs/heads/main/assets/ufart.jpg',
        tags: ['tokenv1'],
    },
    {
        name: 'Looping Collective',
        decimals: 18,
        symbol: 'LOOP',
        address: '0x00fDBc53719604D924226215bc871D55e40a1009',
        chainId: 999,
        logoURI: 'https://framerusercontent.com/images/lIIUKGXhlXzvDN6tTDQ7uNLt4.png?scale-down-to=512',
        tags: ['tokenv1'],
    },
    {
        name: 'Staked LOOP',
        decimals: 18,
        symbol: 'stLOOP',
        address: '0x502EE789B448aA692901FE27Ab03174c90F07dD1',
        chainId: 999,
        logoURI: 'https://framerusercontent.com/images/NcdHu0qIxvy69XWTqIRF74ZOU.png?scale-down-to=512',
        tags: ['tokenv1'],
    },
    {
        address: '0xB09158c8297ACee00b900Dc1f8715Df46B7246a6',
        name: 'Vegas',
        symbol: 'VEGAS',
        decimals: 18,
        chainId: 999,
        logoURI: 'https://i.ibb.co/QjpP9Kvw/favicon.png',
        tags: ['tokenv1'],
    },
    {
        address: '0xFdC42f844f3aa19F8Fc0b2d67d3276cf1eFdC4CA',
        name: 'Rat Race Combat: Skill, Gems, Crypto. 🐀💎',
        symbol: 'RAT',
        decimals: 18,
        chainId: 999,
        logoURI: 'https://app.hyperliquid.xyz/coins/RAT_USDC.svg',
        tags: ['tokenv1'],
    },
].map((token) => ({
    ...token,
    address: token.address.toLowerCase(),
    underlying: hardcodedTokensList.find((t) => t.address === token.address.toLowerCase())?.underlying ?? SupportedUnderlyingAssetSymbols.OTHERS,
}))
